var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flex"},_vm._l((_vm.listViewItems),function(ref,index){
var icon = ref.icon;
var handler = ref.handler;
var active = ref.active;
return _c('li',{key:index,staticClass:"view-type"},[_c('button',{on:{"click":handler}},[_c('icon',{staticClass:"view-type-icon",class:{ active: active },attrs:{"icon":icon}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }